import HostnameLink from "../HostnameLink/HostnameLink"
import DeviceModelImage from "../DeviceModelImage/DeviceModelImage"
import { resolveDeviceModelImage } from "../../Utils/deviceModelImage"

export const shortUser = (value) => {
  const text = String(value || "").trim()
  if (!text) return ""
  const parts = text.split(/\\|\//)
  return parts[parts.length - 1] || text
}

const presenceClass = (status) =>
  String(status || "")
    .toLowerCase()
    .replace(/\s+/g, "-")

/**
 * Shared `inv-device` cell used by ops screens.
 * `record` supplies _id / sysInfo for the link + model art; `hostname`, `user`
 * and `status` override record fields when the row shape differs.
 */
const DeviceCell = ({ record = {}, hostname, user, status, showModel = true }) => {
  const name = hostname ?? record.hostname
  const presence = presenceClass(status ?? record.deviceStatus)
  const model = resolveDeviceModelImage(record)
  const userLabel = shortUser(user ?? record.user)
  const hasModel = showModel && Boolean(model.model || model.manufacturer)

  return (
    <div className="inv-device">
      <DeviceModelImage device={record} size="sm" />
      <div className="inv-device__copy">
        <div className="inv-device__title">
          {presence ? (
            <span
              className={`inv-device__pulse inv-device__pulse--${presence}`}
              aria-hidden
            />
          ) : null}
          <HostnameLink record={{ ...record, hostname: name }}>
            {name || "—"}
          </HostnameLink>
        </div>
        {userLabel || hasModel ? (
          <div className="inv-device__meta" title={user ?? record.user ?? ""}>
            {userLabel ? <span>{userLabel}</span> : null}
            {userLabel && hasModel ? <span className="inv-device__dot" /> : null}
            {hasModel ? (
              <span title={model.displayModel}>{model.label}</span>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default DeviceCell
